module.exports = __webpack_public_path__ + "img/600w户外电源.5ddfc30d.png";